import { useState, useEffect, CSSProperties } from 'react'

import { useProgram } from "../utils/ProgramContext";
import { AdCampaign } from "../models/AdCampaign";
import { useWallet } from "@solana/wallet-adapter-react";
import { Link } from 'react-router-dom';


const styles: { [key: string]: CSSProperties } = {
	list: {
		padding: 0,
		listStyleType: 'none',
	},
	listItem: {
		margin: '10px 0',
		padding: '15px',
		borderRadius: '8px',
		boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
		border: '1px solid rgba(0, 0, 0, 0.1)',
		backgroundColor: '#fff',
	},
	name: {
		fontWeight: 'bold',
		marginBottom: '10px',
	},
	checkbox: {
		marginRight: '10px',
	},
};


const ManagePendingAds = () => {

	const [adCampaigns, setAdCampaings] = useState<AdCampaign[]>([])
	const { program } = useProgram() || {}
	const { publicKey } = useWallet()


	useEffect(() => {

		async function getAccounts() {
			if (!program || !publicKey) {
				return
			}

			const accountsPromises = [];
			for (const index of [1]) { // Assume this will change based on ProviderCount in User
				const [adCampaignPda] = AdCampaign.findAddress(publicKey, index);
				const promiseWithPda = program.account.adCampaign.fetch(adCampaignPda).then(account => {
					return { account, adCampaignPda };
				});
				accountsPromises.push(promiseWithPda);
			}

			const results = await Promise.all(accountsPromises);

			if (results.length == 0) {
				return;
			}

			const res = [];
			for (const { account, adCampaignPda } of results) {
				if (account) {
					res.push(new AdCampaign(account.id as number, account.name as string, account.location as string, adCampaignPda));
				}
			}
			setAdCampaings(res)
		}
		getAccounts()

	}, [publicKey])


	return (
		<main className="flex flex-1 flex-col gap-4 p-4 lg:gap-6 lg:p-6">
			<div className="flex items-center">
				<h1 className="text-lg font-semibold md:text-2xl">Manage Ad Campaign</h1>
			</div>
			<div className="flex flex-1 items-center justify-center rounded-lg border border-dashed shadow-sm">
				<div className="flex flex-col items-center gap-1 text-center">
					<div className="screen-provider-list">
						<ul style={styles.list}>
							{adCampaigns &&
								adCampaigns.map((adCampaign, index) =>
									<li key={index} style={styles.listItem}>
										{adCampaign.name}
										<Link className={"m-5 bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"} to={`/app/manage-ad-campaign/${adCampaign.id}`}>Apply for Providers</Link>
										<Link className={"m-5 bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"} to={`/app/auction/${adCampaign.id}`}>Apply for Auction</Link>
									</li>
								)
							}
						</ul>
					</div>
				</div>
			</div>
		</main>

	);
};

export default ManagePendingAds;

